import { render, staticRenderFns } from "./BranchBulkAdd.vue?vue&type=template&id=d6c6cf4c"
import script from "./BranchBulkAdd.vue?vue&type=script&lang=ts"
export * from "./BranchBulkAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports